<div class="flex flex-col gap-1">
	<div class="flex">
		<app-radio-group
			*ngIf="!displayAsDropdown"
			label="Type"
			[items]="propertyTypeItems"
			[ngModel]="_propertyType?.type"
			type="compact"
			(ngModelChange)="propertyTypeUpdated($event)"
			[labelIcon]="AI_ICON"
			[labelToolTip]="
				(fieldMappings$ | async)?.propertyDetails?.propertyType?.type
					? AI_TOOLTIP
					: ''
			"
			[labelIconClasses]="AI_CLASSES"
			[testHook]="testHooks.TypeRadioGroup"
		></app-radio-group>

		<app-dropdown
			*ngIf="displayAsDropdown"
			label="Type"
			[readonly]="true"
			[ngModel]="selectedPropertyTypeItem?.label"
			(onSelect)="propertyTypeUpdatedDropdown($event)"
			[itemGroups]="[{ items: propertyTypeItems }]"
			class="max-h-12 self-end max-w-[180px] mb-8"
			name="property-types-dropdown"
			[labelIcon]="AI_ICON"
			[labelToolTip]="
				(fieldMappings$ | async)?.propertyDetails?.propertyType?.type
					? AI_TOOLTIP
					: ''
			"
			[labelIconClasses]="AI_CLASSES"
			[testHook]="testHooks.TypeDropdown"
		>
		</app-dropdown>
	</div>

	<div
		[@openClose]
		*ngIf="_propertyType?.type === propertyTypes.OTHER"
		class="flex rounded-lg bg-grey-lighter p-2"
	>
		<app-input
			label="Please specify"
			[ngModel]="_propertyType?.otherType"
			(debounce)="propertyOtherUpdated($event)"
			[testHook]="testHooks.OtherTypeInput"
		></app-input>
	</div>

	<div
		class="flex rounded-lg bg-grey-lighter p-2"
		*ngIf="_propertyType?.type === propertyTypes.CONDO"
		[@openClose]
	>
		<app-radio-group
			label="Condominium type"
			[items]="condoTypes"
			[ngModel]="_propertyType?.condoType"
			type="compact"
			(ngModelChange)="condoTypeUpdated($event)"
			[testHook]="testHooks.CondominiumTypeRadioGroup"
		></app-radio-group>
	</div>
</div>
